//==============================
// Global
//==============================

// No events scheduled
var getEventsCount = $('.visit-events .blog-item').length;
if (getEventsCount < 1) {
  $('.visit-events-none').addClass('show');
}

if (getEventsCount < 3) {
  $('.visit-events').removeClass('blog-grid').addClass('blog-list');
}
